export default "__VITE_ASSET__h58m06wR__"